<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.53125 2.34375C7.96272 2.34375 8.3125 2.69353 8.3125 3.125V4.6875H17.6875V3.125C17.6875 2.69353 18.0373 2.34375 18.4688 2.34375C18.9002 2.34375 19.25 2.69353 19.25 3.125V4.6875H20.0312C21.7571 4.6875 23.1562 6.08661 23.1562 7.8125V19.5312C23.1562 21.2571 21.7571 22.6562 20.0312 22.6562H5.96875C4.24286 22.6562 2.84375 21.2571 2.84375 19.5312V7.8125C2.84375 6.08661 4.24286 4.6875 5.96875 4.6875H6.75V3.125C6.75 2.69353 7.09978 2.34375 7.53125 2.34375ZM21.5938 11.7188C21.5938 10.8558 20.8942 10.1562 20.0312 10.1562H5.96875C5.10581 10.1562 4.40625 10.8558 4.40625 11.7188V19.5312C4.40625 20.3942 5.10581 21.0938 5.96875 21.0938H20.0312C20.8942 21.0938 21.5938 20.3942 21.5938 19.5312V11.7188Z"
                :fill="color" 
            />
            <path
                d="M15.6963 13C15.911 13 16.1129 13.0807 16.2648 13.2273C16.5784 13.53 16.5784 14.0223 16.2649 14.3249L12.693 17.7727C12.5411 17.9193 12.3393 18 12.1245 18C11.9097 18 11.7078 17.9193 11.556 17.7727L9.73553 16.0155C9.58365 15.8689 9.5 15.674 9.5 15.4667C9.5 15.2594 9.58365 15.0645 9.73553 14.9179C9.88734 14.7713 10.0892 14.6905 10.3041 14.6905C10.5188 14.6905 10.7208 14.7713 10.8726 14.9179L12.1244 16.1263L15.1277 13.2273C15.2796 13.0807 15.4815 13 15.6963 13Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCalendarCheck',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>